/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { hydrateSnapshot } from '@/app/store/stateSnapshot/hydrateSnapshotAction';
/* THIS STORE USED FOR MANAGING AUTHENTICATION STATE AND USER INFO */
export interface AuthState {
    isAuthenticated: boolean;
    user: {
        id?: string;
        name?: string;
        firstName?: string;
        lastName?: string;
        email?: string;
        roles?: any;
        language?: string;
    } | null;
    token: string | null;
    lastLogin: number | null;
}

const initialState: AuthState = {
    isAuthenticated: false,
    user: null,
    token: null,
    lastLogin: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login(state, action: PayloadAction<{ user: AuthState['user']; token: string }>) {
            state.isAuthenticated = true;
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.lastLogin = Date.now();
        },
        logout(state) {
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.lastLogin = null;
        },
        updateUser(state, action: PayloadAction<AuthState['user']>) {
            state.user = action.payload;
        },
        setToken(state, action: PayloadAction<string>) {
            state.token = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(hydrateSnapshot, (state, action) => {
            const persisted = action.payload.authStore;
            if (!persisted) return;
            state.isAuthenticated = persisted.isAuthenticated ?? false;
            state.user = persisted.user ?? null;
            state.token = persisted.token ?? null;
            state.lastLogin = persisted.lastLogin ?? null;
        });
    },
});

export const { login, logout, setToken } = authSlice.actions;
export default authSlice.reducer;
